import React from 'react';
import Tabela, {TabelaLinha as TL} from '../../Common/Tabela';
import CelulaHeader from '../../Common/CelulaHeader';
import Celula from '../../Common/Celula'
import styled from 'styled-components';
import history from '../../history';
import { Route } from 'react-router-dom';
import GrupoEmpresasEdit from './GrupoEmpresasEdit';
import AddIcon from '@material-ui/icons/Add';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const FloatingButton = styled(Button)`
  position: absolute;
  bottom: 40px;
  right: 40px;
`

const fmtA = arr => arr.join(",")
const fields = [
  [ "Cod", "Cod" ],
  [ "Nome", "Nome do Grupo" ],
  [ "Membros", "Membros", fmtA ],
]

const TabelaLinha = styled(TL)`
  grid-template-columns: 40px 170px 390px;
`

const GrupoEmpresasUI = ({data, refresh}) => {
  return (
    <div style={{display:"flex", alignItems: "center", flexDirection: "column"}}>
    <Typography variant="display2" gutterBottom>Grupos de Empresas</Typography>
    <Tabela cursor="pointer">
      <TabelaLinha header>
        {fields.map((f,i) => (
          <CelulaHeader key={"a"+i} field={f} />
        ))}
      </TabelaLinha>
      {data.map((item,i0) => (
        <TabelaLinha
          key={"b"+i0}
          onClick={() => history.push(`/grpempresas/${item["Cod"]}`)}
        >
          {fields.map((f,i1) => (<Celula key={"c"+i0+i1}>{f[2] ? f[2](item[f[0]]) : item[f[0]]}</Celula>))}
        </TabelaLinha>
      ))}
    </Tabela>
    <FloatingButton
      variant="fab"
      color="secondary"
      onClick={() => history.push("/grpempresas/n")}
    >
      <AddIcon />
    </FloatingButton>
    <Route path="/grpempresas/:cod" render={props => <GrupoEmpresasEdit {...props} refresh={refresh} />} />
    </div>
  )
}

export default GrupoEmpresasUI
